var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.895431 0.89543 0 2 0H11C11.5523 0 12 0.447715 12 1C12 1.55228 11.5523 2 11 2L2 2V14H11C11.5523 14 12 14.4477 12 15C12 15.5523 11.5523 16 11 16H2C0.89543 16 0 15.1046 0 14V2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07251 7.65259C3.94066 8.00782 4.01742 8.42296 4.30281 8.70843L4.30636 8.71196L6.42346 10.8297C6.81386 11.2203 7.44682 11.2203 7.83722 10.8297C8.22762 10.4392 8.22762 9.80605 7.83722 9.41553L7.42446 9.00263L12.5856 9.00263L12.1728 9.41553C11.7824 9.80605 11.7824 10.4392 12.1728 10.8297C12.5632 11.2203 13.1962 11.2203 13.5866 10.8297L15.7051 8.71052L15.7072 8.70843C15.756 8.65962 15.7987 8.607 15.8353 8.55155L15.9375 8.35005C16.0694 7.99482 15.9926 7.57968 15.7072 7.29421L15.7037 7.29068L13.5866 5.1729C13.1962 4.78238 12.5632 4.78238 12.1728 5.1729C11.7824 5.56342 11.7824 6.19659 12.1728 6.58711L12.5882 7.00264L7.42183 7.00263L7.83722 6.58711C8.22761 6.19659 8.22761 5.56342 7.83722 5.1729C7.44682 4.78237 6.81385 4.78237 6.42345 5.1729L4.30491 7.29212L4.30282 7.29421C4.25402 7.34302 4.21131 7.39564 4.17471 7.45109L4.07251 7.65259Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.21150986b6a4e6e9f78ea6c350504977.svg";
export { ForwardRef as ReactComponent };